<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {};
  },
  methods: {
    tabbarChange(name) {
      this.$router.push('/' + name);
      this.$store.state.tabBar = name;
    },
  },
  created() {},
};
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  background: #f7f5f0;
}

// 导航栏样式
.van-nav-bar {
  background: #2d6a4f;
  border-bottom: none;

  &::after {
    display: none;
  }

  .van-nav-bar__title {
    color: #fff;
    font-weight: normal;
    letter-spacing: 2px;
  }

  .van-nav-bar__text,
  .van-nav-bar__left .van-icon,
  .van-nav-bar__right .van-icon {
    color: #fff;
  }
}

// 按钮样式
.van-button--primary {
  background-color: #2d6a4f;
  border: 1px solid #2d6a4f;
  border-radius: 50px;
  height: 44px;
  letter-spacing: 2px;

  &:active {
    background-color: #1b4332;
    border-color: #1b4332;
  }

  &[disabled] {
    background-color: #ccc;
    border-color: #ccc;
    opacity: 1;
  }
}

.van-button--info {
  background-color: #2d6a4f;
  border: 1px solid #2d6a4f;
}

// 支付按钮金色样式
.van-button.pay-btn {
  background-color: #c9a227;
  border-color: #c9a227;

  &:active {
    background-color: #b08d1f;
    border-color: #b08d1f;
  }
}

// 步进器样式
.van-stepper--round .van-stepper__plus {
  background-color: #2d6a4f !important;
}

.van-stepper--round .van-stepper__minus {
  background-color: #2d6a4f !important;
  color: #fff;
  border: 1px solid #2d6a4f;
}

// 输入框样式
.van-field__label {
  color: #666;
}

.van-field__control::placeholder {
  color: #bbb;
}
</style>
